.<template>
  <div>
    <div v-show="isShow" class="PayTitle">{{ showTitle(title, 0) }}</div>
    <div v-show="isShow" class="PayTitle" style="margin-top: 10px">
      {{ showTitle(title, 1) }}
    </div>
    <div class="pay_class">
      <div
        id="paypal-button-container"
        v-show="isShow"
        style="text-align: center"
      ></div>
      <div v-show="!isShow" style="text-align: center; margin-bottom: 20px">
        <div class="sun-loading"></div>
      </div>
      <div>
        <div class="payDiv payCanl" @click="Noshow">
          <a href="javascript:;">Cancel</a>
        </div>
      </div>
    </div>
    <div class="payFoot">
      <VueFoot :isPay="true" />
    </div>
  </div>
</template>
<script>
import VueFoot from "./Foot.vue";
import load from "../utils/LoadScript";
import { GetTime } from "../utils/JsonIsNull";
import { SubCountly } from "@/api/MovieApi";
export default {
  data() {
    return {
      title: "",
      isShow: false,
      time: null,
    };
  },
  components: {
    VueFoot,
  },
  methods: {
    showTitle(title, index) {
      try {
        if (!title) return "";
        let str = title.toString();
        return str.split("&&")[index];
      } catch (err) {
        return "";
      }
    },
    Noshow() {
      this.$bus.$emit("ShowPay", "0", "");
      if (this.$route.name === "details") {
        this.$bus.$emit("ShowDetailsPay", "");
      }
      this.$bus.$emit(
        "CountlyEven",
        process.env.PayPageLodingTime,
        GetTime(this.time, Date.now())
      );
    },
    ShowPay(Str) {
      try {
        let That = this;
        paypal
          .Buttons({
            style: {
              shape: "pill",
              color: "gold",
              layout: "vertical",
              label: "paypal",
            },
            createSubscription: function (data, actions) {
              SubCountly(Str);
              return actions.subscription.create({
                plan_id: Str,
              });
            },
            onApprove: function (data, actions) {
              console.log("createSubscription");
              console.log(data);
              That.$bus.$emit("checkuser", data);
            },
          })
          .render("#paypal-button-container")
          .then(() => {
            this.isShow = true;
            this.time = Date.now();
          })
          .catch(() => {
            this.$bus.$emit("toast", "Failed to obtain subscription content");
          });
      } catch (ex) {
        this.$bus.$emit("toast", "Failed to obtain subscription content");
      }
    },
    Renderingpay(res, data) {
      let info = (document.getElementById("paypal-button-container").innerHTML =
        "");
      this.title = data;
      this.ShowPay(res);
    },
  },
  mounted() {
    this.$bus.$on("pay", (res) => {
      this.isShow = false;
      this.$bus.$emit("Countly", res.products);
      let Payjs = document.getElementById(
        "https://www.paypal.com/sdk/js?client-id=" +
          res.client_id +
          "&vault=true&intent=subscription"
      );
      if (Payjs !== null) {
        this.Renderingpay(res.products, res.info);
        return;
      }
      load(
        "https://www.paypal.com/sdk/js?client-id=" +
          res.client_id +
          "&vault=true&intent=subscription",
        () => {
          this.Renderingpay(res.products, res.info);
        }
      );
    });
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Pay.vue